module.exports = __webpack_public_path__ + "assets/kids/img/logo-dgfpi.a96319f7.png";